import { formatPhone } from 'src/utils/format-phone';
import { Skeleton } from '@/components/ui/skeleton';
import { trpc } from 'src/trpc';
import { useToast } from 'src/components/useToast';
import { InvoiceSelectCustomerSheet } from './InvoiceSelectCustomerSheet';

export const InvoiceCustomerSection = ({
  userId,
  invoiceId,
  isLoading,
  refetchInvoice,
}: {
  userId: string;
  invoiceId: string;
  isLoading?: boolean;
  refetchInvoice: () => void;
}) => {
  const { data: user, isLoading: isUserLoading } = trpc.admin.user.getUser.useQuery(userId);
  const { successToast, errorToast } = useToast();

  const { mutate: updateInvoiceCustomer, isPending: isUpdatingCustomer } =
    trpc.admin.invoice.adminUpdateInvoiceCustomer.useMutation({
      onSuccess: async () => {
        successToast({
          title: 'Customer Updated',
          description: 'Invoice customer changed successfully.',
        });
        refetchInvoice();
      },
      onError: (error) => {
        errorToast({
          title: 'Error',
          description: error.message || 'Failed to change invoice customer',
        });
      },
    });

  const handleCustomerChange = (customerId: string) => {
    updateInvoiceCustomer({ invoiceId, customerId });
  };

  return (
    <div className="card flex flex-col gap-4 justify-start relative">
      <div className="flex flex-col gap-1 w-full">
        <InvoiceSelectCustomerSheet
          user={user}
          isLoading={isUserLoading || isLoading || isUpdatingCustomer}
          onChangeCustomer={handleCustomerChange}
        />
        <label className="label text-xs">Customer Details</label>

        {isUserLoading || isLoading ? (
          <Skeleton className="w-20 h-4" />
        ) : (
          <p className="text-text-primary text-sm font-medium underline">
            {user?.name?.first} {user?.name?.last}
          </p>
        )}
      </div>
      <div className="flex flex-col gap-1 w-full">
        <label className="label text-xs">Contact Information</label>
        {isUserLoading || isLoading ? (
          <>
            <Skeleton className="w-20 h-4" />
            <Skeleton className="w-20 h-4" />
          </>
        ) : (
          <>
            <p className="text-text-primary text-sm font-medium">{user?.email}</p>
            <p className="text-text-primary text-sm font-medium">
              {formatPhone(user?.phone?.replace('+1', '') || '')}
            </p>
          </>
        )}
      </div>
    </div>
  );
};
